module.exports = __webpack_public_path__ + "static/1-004-e86aec1c251376a4a1e158de22a85e4b.png";